import { useState, useEffect } from 'react';

const useDocumentWidth = () => {
  const [docWidth, setDocWidth] = useState<number>(0);

  useEffect(() => {
    const getDocWidth = () => {
      const width = document.documentElement.clientWidth || document.body.clientWidth;
      setDocWidth(width);
    };
    getDocWidth();

    const resizeHandle = () => {
      window.requestAnimationFrame(() => getDocWidth());
    };

    window.addEventListener('resize', resizeHandle);

    return () => {
      window.removeEventListener('resize', resizeHandle);
    };
  }, []);

  return docWidth;
};

export default useDocumentWidth;
